// Adapted from @react-admin/ra-form-layout@1.9.0 — see ../README.md
import { Button, Grid, Toolbar as MUIToolbar } from '@mui/material'
import { SaveButton, useTranslate } from 'react-admin'

const noop = (): void => undefined

/**
 * The toolbar displayed at the bottom of <WizardForm>.
 *
 * Like WizardProgress this is only the default — GuidedBoatForm passes its own.
 * The two translation lookups carry inline fallbacks so they render the same
 * text without the Enterprise Edition translation catalogue, which this repo
 * never loaded.
 */
export const WizardToolbar = ({
  hasPreviousStep = false,
  hasNextStep = false,
  onPreviousClick = noop,
  onNextClick = noop,
  invalid,
}: WizardToolbarProps) => {
  const translate = useTranslate()

  return (
    <MUIToolbar>
      <Grid
        container
        direction='row'
        sx={{ justifyContent: 'space-between', alignItems: 'center' }}
      >
        <Grid>
          {hasPreviousStep ? (
            <Button variant='text' onClick={onPreviousClick}>
              {translate('ra-form-layout.action.previous', { _: 'Previous' })}
            </Button>
          ) : null}
        </Grid>
        <Grid>
          {hasNextStep ? (
            <Button disabled={invalid} variant='contained' color='primary' onClick={onNextClick}>
              {translate('ra-form-layout.action.next', { _: 'Next' })}
            </Button>
          ) : (
            <SaveButton disabled={invalid} alwaysEnable={false} />
          )}
        </Grid>
      </Grid>
    </MUIToolbar>
  )
}

export type WizardToolbarProps = {
  hasPreviousStep?: boolean
  hasNextStep?: boolean
  onPreviousClick?: () => void
  onNextClick?: () => void
  invalid?: boolean
}

export default WizardToolbar
